import { useTranslation, Trans } from "react-i18next";

import set1 from '../../img/InvestmentPlans/set1.png'
import set2 from '../../img/InvestmentPlans/set2.png'
import set3 from '../../img/InvestmentPlans/set3.png'

function SetUp() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('investment.28')}</p>
            <p className="poppins text-[#1A0402] text-[16px] font-[500] xl:text-[20px] leading-[1.5] mt-[12px]">{t('investment.29')}</p>
            <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[30px] xl:mt-[40px]">
                <img src={set1} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px] flex gap-[30px]">
                        <div className="rounded-[10px] bg-[#637BF5] w-[36px] h-[36px] xl:w-[46px] xl:h-[46px] flex items-center justify-center flex-shrink-0">
                            <p className="text-white poppins leading-[1.2] font-[500] text-[16px] xl:text-[24px]">1</p>
                        </div>
                        <div>
                            <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('investment.30')}</p>
                            <p className="inter text-[14px] text-[#000000B2] xl:max-w-[431px] mt-[10px] xl:mt-[20px]">{t('investment.31')}</p>
                        </div>  
                    </div>
                </div>
            </div>
            <div className="flex flex-col xl:flex-row-reverse gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                <img src={set2} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px] flex gap-[30px]">
                        <div className="rounded-[10px] bg-[#637BF5] w-[36px] h-[36px] xl:w-[46px] xl:h-[46px] flex items-center justify-center flex-shrink-0">
                            <p className="text-white poppins leading-[1.2] font-[500] text-[16px] xl:text-[24px]">2</p>
                        </div>
                        <div>
                            <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('investment.32')}</p>
                            <p className="inter text-[14px] text-[#000000B2] xl:max-w-[431px] mt-[10px] xl:mt-[20px]">{t('investment.33')}</p>
                        </div>  
                    </div>
                </div>
            </div>
            <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px] mt-[10px] xl:mt-[20px]">
                <img src={set3} className="rounded-[4px]" alt="" />
                <div className="rounded-[4px] border w-full flex flex-col justify-center items-center">
                    <div className="px-[20px] py-[40px] flex gap-[30px]">
                        <div className="rounded-[10px] bg-[#637BF5] w-[36px] h-[36px] xl:w-[46px] xl:h-[46px] flex items-center justify-center flex-shrink-0">
                            <p className="text-white poppins leading-[1.2] font-[500] text-[16px] xl:text-[24px]">3</p>
                        </div>
                        <div>
                            <p className="poppins xl:text-[32px] text-[20px] leading-[1.2] text-[#1A0402] font-[500]">{t('investment.34')}</p>
                            <p className="inter text-[14px] text-[#000000B2] xl:max-w-[431px] mt-[10px] xl:mt-[20px]">{t('investment.35')}</p>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default SetUp;
 